import { sidebarOptions } from "../navigation";
import { ROLES } from "../../config";
import { isOnboardingPathAllowed } from "../../Routes/accessPolicy";

const ADMIN = ROLES.COMPANY_ADMIN;
const EMPLOYEE = ROLES.EMPLOYEE;
const BOTH = [ADMIN, EMPLOYEE];

const action = (id, label, path, role, command, keywords = "") => ({
  id, label, path, roles: [role], type: "action", command,
  keywords,
});
const page = (id, label, path, roles, keywords = "") => ({
  id, label, path, roles, type: "page", keywords: `view ${keywords}`,
});

export const searchCatalog = [
  action("add-employee", "Add One Employee", "/add-employee-details", ADMIN, undefined, "single individual new"),
  action("upload-employees", "Add Multiple Employees", "/employee-details/upload", ADMIN, undefined, "upload import bulk multiple file excel"),
  action("add-department", "Add Department", "/department", ADMIN, "add-department"),
  action("add-shift", "Add Shift", "/shifts", ADMIN, "add-shift"),
  action("add-holiday", "Add Holiday", "/public-holidays", ADMIN, "add-holiday"),
  action("add-salary-template", "Add Salary Template", "/salary-templates", ADMIN, "add-salary-template"),
  action("apply-leave", "Apply Leave", "/leave-application", EMPLOYEE),
  action("apply-remote-work", "Apply Remote Work", "/wfh/apply", EMPLOYEE),
  ...sidebarOptions.map((option) => ({
    ...page(`page-${option.role}-${option.name || "dashboard"}`, option.label,
      `/${option.name}`, option.role === "BOTH" ? BOTH : [option.role]),
    icon: option.icon,
    feature: option.feature,
    keywords: `view ${option.name.replace(/[-/]/g, " ")}`,
  })),
  page("onboarding", "Company Setup", "/onboarding", BOTH, "onboarding progress"),
  page("attendance-report", "Attendance Report", "/attendance-report", [ADMIN]),
  page("regularization", "Regularization Requests", "/regularization-requests", [ADMIN]),
  page("leave-approvals", "Leave Applications", "/leave-applied", [ADMIN]),
  page("salary-logs", "Salary Logs", "/salary/logs", [ADMIN], "payroll payment history"),
  page("bonus", "Bonus", "/bonus", [ADMIN]),
  page("advance-bonus", "Advance and Bonus", "/advance-and-bonus", [ADMIN]),
  page("pf", "Provident Fund", "/provident-fund", [ADMIN], "PF"),
  page("esic", "ESIC", "/esic", [ADMIN]),
  page("professional-tax", "Professional Tax", "/professional-tax", [ADMIN], "PT"),
  page("resigned-employees", "Resigned Employees", "/resigned-employee-details", [ADMIN]),
  page("leave-structure", "Leave Structure", "/company-settings/leave-structure", [ADMIN]),
  page("salary-structure", "Salary Structure", "/company-settings/salary-structure", [ADMIN], "earnings payroll"),
  page("statutory-components", "Statutory Salary Components", "/company-settings/salary-structure/statutory-components", [ADMIN]),
  page("my-account", "My Account", "/my-account", [EMPLOYEE], "profile"),
  page("edit-account", "Edit My Account", "/my-account/edit", [EMPLOYEE], "profile"),
  page("punch-in", "Attendance Punch In", "/attendance-punch-in", [EMPLOYEE], "check in"),
  page("punch-logs", "Punch Logs", "/attendance-punch-in/logs", [EMPLOYEE]),
  page("remote-attendance", "Remote Work Attendance", "/work-from-home", [EMPLOYEE]),
];

export function getAvailableEntries({ role, hasAccess, isCheckingAccess, companyCompletionStatus, features = {} }) {
  if (!hasAccess || isCheckingAccess) return [];
  return searchCatalog.filter((entry) =>
    entry.roles.includes(role) &&
    (!entry.feature || features[entry.feature]) &&
    (companyCompletionStatus === true || isOnboardingPathAllowed(entry.path, role))
  );
}

const synonymGroups = [
  ["add", "create", "new"],
  ["edit", "update", "modify"],
  ["view", "show", "open"],
  ["apply", "request"],
  ["upload", "import"],
  ["employee", "employees", "user", "users", "staff"],
  ["shift", "shifts"],
  ["department", "departments"],
  ["holiday", "holidays"],
  ["template", "templates"],
  ["leave", "leaves"],
  ["salary", "salaries", "payroll"],
];
const synonyms = Object.fromEntries(synonymGroups.flatMap((group) => group.map((word) => [word, group[0]])));
const normalize = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim().replace(/\s+/g, " ");
const tokens = (value) => normalize(value)
  .replace(/\b(work from home|remote work|wfh)\b/g, "remotework")
  .split(" ").filter(Boolean).map((word) => synonyms[word] || word);

export function searchEntries(entries, query) {
  const normalizedQuery = normalize(query);
  if (!normalizedQuery) return entries;
  const queryTokens = tokens(query);
  return entries.map((entry, index) => {
    const words = tokens(`${entry.label} ${entry.keywords || ""}`);
    const matches = queryTokens.every((token) => words.some((word) => word.startsWith(token)));
    const label = normalize(entry.label);
    const rank = label === normalizedQuery ? 0 : label.startsWith(normalizedQuery) ? 1 : 2;
    return { entry, index, matches, rank };
  }).filter(({ matches }) => matches)
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .map(({ entry }) => entry);
}
